import React from 'react';
import classnames from 'classnames';

import styles from './index.css';

const Input = ({ className, renderIcon, onClickIcon = () => {}, ...other }) => (
	<div
		className={classnames(styles.input, className, {
			[styles.icon]: typeof renderIcon !== 'undefined',
		})}
	>
		<input {...other} />
		{typeof renderIcon !== 'undefined' && (
			<button className={styles.icon} onClick={onClickIcon} type="button">
				{renderIcon()}
			</button>
		)}
	</div>
);

export default Input;
